module.exports = __webpack_public_path__ + "fonts/Helios.b71720ba.otf";